"use client"
import {usePathname} from "next/navigation"
import FooterNewView from "@/app/components/base/FooterNewView"

export default function FooterNewClient() {
    const pathname = usePathname() || ''

    return <FooterNewView pathname={pathname} year={new Date().getFullYear()} />
}
